import type { AccountingPolicy as A } from '@libs/domain';
import type { SettlementDateCriteria } from '@libs/enums';
import { settlementDateCriteria } from '@libs/enums';
import { dateToStr, strToDate } from '@ps-smart-cp/ppfw-client';

class AccountingPolicy
  implements
    Pick<
      A['schema'],
      | 'beginningYearMonth'
      | 'currencyValidNoDecimalPlaces'
      | 'displayCurrency'
      | 'settlementDate'
      | 'settlementDateBasis'
    >
{
  private constructor(
    readonly beginningYearMonth: Date | null,
    readonly settlementDateBasis: SettlementDateCriteria,
    readonly settlementDate: string,
    readonly displayCurrency: string,
    readonly currencyValidNoDecimalPlaces: number,
  ) {}

  static init() {
    return new AccountingPolicy(strToDate('190001'), settlementDateCriteria.enum.eom, '', '', 0);
  }

  static fromRaw(r: AccountingPolicyRaw) {
    return new AccountingPolicy(
      strToDate(r.beginningYearMonth),
      settlementDateCriteria.toEnum(r.settlementDateBasis),
      r.settlementDate,
      r.displayCurrency,
      r.currencyValidNoDecimalPlaces,
    );
  }
}

export { AccountingPolicy };

export class AccountingPolicyRaw
  implements
    Pick<A['record'], 'beginningYearMonth' | 'displayCurrency' | 'settlementDate' | 'settlementDateBasis'>
{
  private constructor(
    readonly beginningYearMonth: string,
    readonly settlementDateBasis: string,
    readonly settlementDate: string,
    readonly displayCurrency: string,
    readonly currencyValidNoDecimalPlaces: number,
  ) {}

  static fromModel(basicInfoListSearch: AccountingPolicy) {
    return new AccountingPolicyRaw(
      dateToStr(basicInfoListSearch.beginningYearMonth).replaceAll('/', '').slice(0, 6),
      basicInfoListSearch.settlementDateBasis,
      basicInfoListSearch.settlementDate,
      basicInfoListSearch.displayCurrency,
      basicInfoListSearch.currencyValidNoDecimalPlaces,
    );
  }
}
